import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import type { ReactElement } from 'react';
import { ApiRouteMonitorProvider } from './contexts/ApiRouteMonitor';
import { NotificationProvider } from './contexts/NotificationContext';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './pages/Dashboard/Dashboard';
import Login from './pages/Login/Login';
import Register from './pages/Register/Register';
import SettingsPage from './pages/Settings/SettingsPage';
import AuthDebug from './components/AuthDebug';
import Documentation from './pages/Documentation/Documentation';
import NotificationContainer from './components/NotificationContainer';
import { useAuth } from './hooks/useAuth';
import './App.scss';

const AppContent: React.FC = () => {
  const {
    isLoading,
    isInitialized,
    canSeeAuthDebug,
    checkAuth
  } = useAuth();

  // Initialize auth on app start
  useEffect(() => {
    console.log('🚀 App iniciando - verificando autenticação...');
    checkAuth()
      .then((result) => {
        console.log('✅ Verificação de auth concluída:', result);
      })
      .catch((error) => {
        console.error('❌ Erro na verificação de auth:', error);
      });
  }, [checkAuth]);

  // Show loading spinner while checking auth
  if (!isInitialized || isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <Routes>
        {/* Rotas públicas */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Rota principal - Home com features */}
        <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />

        {/* Settings com permissões granulares */}
        <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />

        {/* Documentação */}
        <Route path="/documentation" element={<ProtectedRoute><Documentation /></ProtectedRoute>} />
      </Routes>
      {/* AuthDebug para superadmin e admin */}
      {canSeeAuthDebug && <AuthDebug />}
      {/* Notification Container */}
      <NotificationContainer />
    </>
  );
};

const App: React.FC = () => {
  return (
    <NotificationProvider>
      <ApiRouteMonitorProvider>
        <AppContent />
      </ApiRouteMonitorProvider>
    </NotificationProvider>
  );
};

export default App; 